// import React, { useState, useEffect } from 'react';
// import { fetchAccounts } from '../../api';
// import './Accounts.css';

// interface Position {
//   positionName: string;
//   currentBalance: number;
//   currencyCode: string;
//   accountNum: string;
// }

// interface Account {
//   positions: Position[];
//   accountNum: string;
//   accountName: string;
//   accountType: string;
//   firstName: string;
//   lastName: string;
// }

// interface ApiResponse {
//   creditCard?: Account[];
//   checking?: Account[];
//   savings?: Account[];
// }

// const Accounts = () => {
//   const [accounts, setAccounts] = useState<Position[]>([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState<string | null>(null);
//   const [isDemoData, setIsDemoData] = useState(false);

//   useEffect(() => {
//     const loadAccounts = async () => {
//       try {
//         setLoading(true);
//         setError(null);
//         setIsDemoData(false);
        
//         const data: ApiResponse = await fetchAccounts() || [{}];
        
//         // Check if we're showing demo data by comparing the stored user ID
//         const storedUserId = localStorage.getItem('currentUserId');
//         if (storedUserId && storedUserId !== 'nova.brooks') {
//           // Check if we got any data for this user
//           const hasData = (data.checking && data.checking.length > 0) || 
//                          (data.savings && data.savings.length > 0) || 
//                          (data.creditCard && data.creditCard.length > 0);
          
//           // If we have a stored user ID that's different from nova.brooks, 
//           // but we didn't get data, it means we fell back to demo data
//           if (!hasData) {
//             setIsDemoData(true);
//           }
//         }
        
//         // Extract positions from all account types (checking, savings, creditCard)
//         const allPositions: Position[] = [];
        
//         // Handle checking accounts
//         if (data.checking && Array.isArray(data.checking)) {
//           data.checking.forEach(account => {
//             if (account.positions && Array.isArray(account.positions)) {
//               allPositions.push(...account.positions);
//             }
//           });
//         }
        
//         // Handle savings accounts
//         if (data.savings && Array.isArray(data.savings)) {
//           data.savings.forEach(account => {
//             if (account.positions && Array.isArray(account.positions)) {
//               allPositions.push(...account.positions);
//             }
//           });
//         }
        
//         // Handle credit card accounts
//         if (data.creditCard && Array.isArray(data.creditCard)) {
//           data.creditCard.forEach(account => {
//             if (account.positions && Array.isArray(account.positions)) {
//               allPositions.push(...account.positions);
//             }
//           });
//         }
        
//         setAccounts(allPositions);
//       } catch (err) {
//         console.error('Failed to load accounts:', err);
//         setError('Failed to load accounts. Please try again later.');
//       } finally {
//         setLoading(false);
//       }
//     };

//     loadAccounts();
//   }, []);

//   const formatBalance = (balance: number, currency: string = 'USD') => {
//     const formattedBalance = new Intl.NumberFormat('en-US', {
//       style: 'currency',
//       currency: currency,
//       minimumFractionDigits: 2,
//       maximumFractionDigits: 2,
//     }).format(balance);
    
//     return formattedBalance;
//   };

//   if (loading) {
//     return (
//       <div className="accounts-container">
//         <h1>Your Accounts</h1>
//         <div className="loading">Loading accounts...</div>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="accounts-container">
//         <h1>Your Accounts</h1>
//         <div className="error">{error}</div>
//         <button onClick={() => window.location.reload()}>Retry</button>
//       </div>
//     );
//   }

//   return (
//     <div className="accounts-container">
//       <h1>Your Accounts</h1>
//       {isDemoData && (
//         <div className="demo-notice">
//           <p>Note: Showing demo account data. Your account "{localStorage.getItem('currentUserId')}" was not found in our system.</p>
//         </div>
//       )}
//       {accounts.length === 0 ? (
//         <div className="no-accounts">No accounts found.</div>
//       ) : (
//         <ul className="accounts-list">
//           {accounts.map((account, index) => (
//             <li key={`${account.accountNum}-${index}`} className="account-item">
//               <div className="account-info">
//                 <span className="account-name">{account.positionName || `Account ${index + 1}`}</span>
//                 <span className="account-number">****{account.accountNum.slice(-4)}</span>
//               </div>
//               <span 
//                 className={`account-balance ${account.currentBalance < 0 ? 'negative' : 'positive'}`}
//               >
//                 {formatBalance(account.currentBalance, account.currencyCode)}
//               </span>
//             </li>
//           ))}
//         </ul>
//       )}
//     </div>
//   );
// };

// export default Accounts;
import React, { useState, useEffect } from 'react';
import './Accounts.css';

interface AccountInfo {
  accountName: string;
  accountNumber: string;
  balance: number;
  currency: string;
  core: string;
}

const Accounts = () => {
  const [accounts, setAccounts] = useState<AccountInfo[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate loading delay
    const demoAccounts: AccountInfo[] = [
      {
        accountName: 'Primary Checking',
        accountNumber: '400000996591',
        balance: 25563.78,
        currency: 'USD',
        core: 'thought_machine',
      },
      {
        accountName: 'Primary Savings',
        accountNumber: '400000232262',
        balance: 15563.0,
        currency: 'USD',
        core: 'fis',
      },
    ];

    setTimeout(() => {
      setAccounts(demoAccounts);
      setLoading(false);
    }, 300); // simulate loading time
  }, []);

  const formatBalance = (balance: number, currency: string = 'USD') =>
    new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(balance);

  if (loading) {
    return (
      <div className="accounts-container">
        <h1>Your Accounts</h1>
        <div className="loading">Loading accounts...</div>
      </div>
    );
  }

  return (
    <div className="accounts-container">
      <h1>Your Accounts</h1>
      {accounts.length === 0 ? (
        <div className="no-accounts">No accounts found.</div>
      ) : (
        <ul className="accounts-list">
          {accounts.map((account, index) => (
            <li key={`${account.accountNumber}-${index}`} className="account-item">
              <div className="account-info">
                <span className="account-name">{account.accountName}</span>
                <span className="account-number">****{account.accountNumber.slice(-4)}</span>
              </div>
              <span
                className={`account-balance ${account.balance < 0 ? 'negative' : 'positive'}`}
              >
                {formatBalance(account.balance, account.currency)}
              </span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default Accounts;
